import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconForkKnife: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fork-knife, cable, restaurant, cutlery"><path d="M4.75 3.75V10.9688L6.25 12.5156V20.25H9.25V12.5156L10.75 10.9688V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 3.75V9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 20.25V3.75C18.4541 3.75 14.2083 7 13.75 15.25H16.25V20.25H19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconForkKnife;
